module.exports = __webpack_public_path__ + "media/images/icons/icon-instagram-3624d16d1d51ff7b906bb30f8107aca7.svg";